import $ from 'jquery';

window.secureAccessItem = function(id) {
    $.window({
        id: 'secureAccessItem'+id,
        title: 'Accès sécurisé',
        url: 'admin/galeries/image/unlock/' + id,
        icon: 'secure-key',
        method: 'ajax',
        maxWidth: -1, // the minimum width, if -1 means no checking
        maxHeight: -1, // the minimum height, if -1 means no checking
        showFooter: false,
        maximizable: false,
        closable: true,
        minimizable: false,
        showModal: true,
        width: 560,
        height: 550,
        checkBoundary: true,
        withinBrowserWindow: false,
        onIframeEnd: function() {},
        onClose: function() {
            browserActionRun('refresh');
        }
    });
};

$(function() {
    if (!$('.gallery').length) return;

    var galleryScrollMap = {};
    var currentGalleryId = 'main';

    var $window = $(window);
    var $htmlBody = $('html, body');
    var $galleryRoot = $('.gallery');

    var GalleryApp = {
        init: function() {
            // Un seul écouteur global au démarrage (Délégation de clics propre)
            this.initGlobalEvents();
            this.loadContainerImages($('#galerie_root'));

            var resizeTimer;
            $window.on('resize', function () {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(GalleryApp.calculateLayout.bind(GalleryApp), 200);
            });

            $window.on('load', function() {
                setTimeout(GalleryApp.calculateLayout.bind(GalleryApp), 300);
                GalleryApp.fetchExternalData();
            });
        },

        initGlobalEvents: function() {
            $galleryRoot.on('click', '.gallery__item-link', function(e) {
                var $link = $(this);

                if ($link.hasClass('gallery__item-link--album') || $link.hasClass('gallery__item-link--parent')) {
                    e.preventDefault();
                    var id = $link.closest('.gallery__item').data('id') || $link.data('id');
                    GalleryApp.showGallery($link, id);
                }
                else if ($link.hasClass('gallery__item-link--secure')) {
                    e.preventDefault();
                    var id = $link.closest('.gallery__item').data('id') || $link.data('id');
                    if (window.secureAccessItem) {
                        window.secureAccessItem(id);
                    }
                }
            });

            $galleryRoot.on('click', '.gallery__back-btn', function(e) {
                e.preventDefault();
                GalleryApp.showMain(this);
            });
        },

        doTransition: function($gallery, $oldContainer, $newContainer, isMain, targetId) {
            // Préchargement immédiat des images du conteneur cible en amont de la transition
            this.loadContainerImages($newContainer);

            var currentHeight = $gallery.height();
            var $backLink = $gallery.find('.gallery__back-link');

            // On s'assure que le nouveau conteneur redevient calculable par le GPU
            $newContainer.css({ visibility: 'visible', pointerEvents: 'auto' });

            $newContainer.css({ display: 'block', position: 'relative', opacity: 0 });
            $backLink.css('display', isMain ? 'none' : 'block');

            var targetHeight = $newContainer.outerHeight(true);
            if (!isMain && $backLink.length) {
                targetHeight += $backLink.outerHeight(true);
            }

            $newContainer.css({ display: 'none', opacity: 1 });
            $backLink.css('display', isMain ? 'block' : 'none');

            $gallery.css({ height: currentHeight, overflow: 'hidden' });

            if (isMain) {
                $backLink.fadeOut(400);
            } else {
                $backLink.fadeIn(400);
            }

            $oldContainer.css({
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                zIndex: 1
            }).fadeOut(400, function() {
                // FORCE LE NAVIGATEUR A IGNORER CE BLOC :
                // visibility: hidden retire le bloc de l'arbre de rendu du GPU
                $(this).css({
                    position: '', top: '', left: '', width: '', zIndex: '',
                    visibility: 'hidden', pointerEvents: 'none'
                });
            });

            $gallery.animate({ height: targetHeight }, 400, function() {
                $gallery.css({ height: '', overflow: '' });
            });

            $newContainer.css({
                position: 'relative',
                zIndex: 2
            }).fadeIn(400, function() {
                GalleryApp.storeAndRestoreScroll(targetId);
            });
        },

        showMain: function(element) {
            var $gallery = element ? $(element).closest('.gallery') : $('.gallery');
            var $oldContainer = $gallery.find('.gallery__container:visible').not('#galerie_root');
            var $newContainer = $gallery.find('#galerie_root');
            this.doTransition($gallery, $oldContainer, $newContainer, true, 'main');
        },

        showGallery: function(element, id) {
            var $gallery = element ? $(element).closest('.gallery') : $('.gallery');
            var $oldContainer = $gallery.find('.gallery__container:visible').not('#galerie_' + id);
            var $newContainer = $gallery.find('#galerie_' + id);
            this.doTransition($gallery, $oldContainer, $newContainer, false, id);
        },

        storeAndRestoreScroll: function(targetId) {
            galleryScrollMap[currentGalleryId] = $window.scrollTop();

            var desiredScroll;
            if (typeof galleryScrollMap[targetId] !== 'undefined') {
                desiredScroll = galleryScrollMap[targetId];
            } else {
                var $target = $('#galerie_' + targetId);
                if ($target.length) {
                    desiredScroll = $target.offset().top - 50;
                }
            }

            var currentScroll = $window.scrollTop();

            if (typeof desiredScroll !== 'undefined' && Math.abs(desiredScroll - currentScroll) >= 100) {
                $htmlBody.stop(true, true).animate({ scrollTop: desiredScroll }, 400);
            }

            currentGalleryId = targetId;
        },

        calculateLayout: function() {
            // Géré par CSS Grid
        },

        loadContainerImages: function($container) {
            $container = $container || $galleryRoot;

            // Activer les images <img> avec data-src
            $container.find('img[data-src]').each(function() {
                var $img = $(this);
                var src = $img.attr('data-src');
                if (src) {
                    $img.attr('src', src);
                    $img.removeAttr('data-src');
                }
            });

            // Rétrocompatibilité avec d'anciens conteneurs avec background-image
            $container.find('.gallery__image:not(img)[data-src]').each(function() {
                var $el = $(this);
                var src = $el.attr('data-src') || $el.data('src');
                if (src) {
                    $el.css('background-image', 'url(' + src + ')');
                    $el.removeAttr('data-src').removeData('src');
                }
            });
        },

        updateVisibleImages: function($context) {
            this.loadContainerImages($context);
        },

        fetchExternalData: function() {
            $galleryRoot.find('.gallery__container[data-external]').each(function() {
                var $container = $(this);
                $.ajax({
                    url: $container.data('external'),
                    type: 'GET',
                    dataType: 'json',
                    success: function(response) {
                        if (response && response.data) {
                            GalleryApp.importData($container, response.data, true);
                        }
                    }
                });
            });
        },

        importData: function($container, data, refreshLayout) {
            var $group = $container.find('.gallery__group');
            var tileWidth = $group.data('tile-width');
            var tileHeight = $group.data('tile-height');
            var parentGalId = $container.data('id');
            var html = '';

            if (data.url_th) {
                var $galLink = $('.gallery__item[data-id="' + parentGalId + '"]');
                var $img = $galLink.find('.gallery__image');
                $img.attr('data-src', data.url_th).data('src', data.url_th);
                this.updateVisibleImages($galLink);
            }

            if (data.childs && data.childs.length > 0) {
                $.each(data.childs, function(index, item) {
                    if (item.actif && !item.password_code) {
                        var id = parentGalId + '_' + item.id;
                        var galHtml = '<div class="gallery__container" id="galerie_' + id + '" data-id="' + id + '" style="display:none; visibility:hidden;">' +
                            '<div class="gallery__header"><h2 class="gallery__title">' + item.name + '</h2></div>' +
                            '<div class="gallery__group" data-tile-width="' + tileWidth + '" data-tile-height="' + tileHeight + '"></div>' +
                            '</div>';

                        $galleryRoot.append(galHtml);
                        var $newContainer = $('#galerie_' + id);

                        html += GalleryApp.createTileHtml({
                            id: id,
                            name: item.name,
                            thumb: item.url_th,
                            type: 'GalerieAlbum',
                            tileWidth: tileWidth,
                            tileHeight: tileHeight,
                            linkClass: 'gallery__item-link--album',
                            linkAttr: 'data-id="' + id + '"'
                        });

                        GalleryApp.importData($newContainer, item);
                    }
                });
            }

            if (data.images && data.images.length > 0) {
                $.each(data.images, function(index, item) {
                    if (item.actif && !item.password_code) {
                        var id = parentGalId + '_' + item.id;
                        html += GalleryApp.createTileHtml({
                            id: id,
                            name: item.name,
                            thumb: item.url_th,
                            type: 'GalerieImage',
                            tileWidth: tileWidth,
                            tileHeight: tileHeight,
                            linkClass: 'gallery__item-link--lightbox',
                            linkAttr: 'href="' + item.url + '" rel="gallery_' + parentGalId + '" data-fancybox="gallery_' + parentGalId + '"'
                        });
                    }
                });
            }

            $group.append(html);

            if (refreshLayout) {
                this.updateVisibleImages();
            }
        },

        createTileHtml: function(options) {
            return '<div class="gallery__item gallery__item--' + options.type + '" data-id="' + options.id + '">' +
                '<a class="gallery__item-link ' + options.linkClass + '" ' + options.linkAttr + ' data-caption="' + options.name + '" title="' + options.name + '">' +
                '<div class="gallery__item-content">' +
                '<div class="gallery__image-wrapper">' +
                '<img class="gallery__image" src="' + options.thumb + '">' +
                '</div>' +
                '<div class="gallery__caption"><span>' + options.name + '</span></div>' +
                '</div></a></div>';
        }
    };

    window.galerieTpl = GalleryApp;
    GalleryApp.init();
});